/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/check'
export default icon
